var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKindergarten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9122 9.65316L41.9865 17.1797C40.4904 21.0286 36.1574 22.9358 32.3085 21.4397L32.0298 21.3313C28.3348 19.895 24.1752 21.726 22.7389 25.4209V25.4209C21.3026 29.1158 17.1429 30.9468 13.448 29.5105L13.1692 29.4021C9.32035 27.906 4.98736 29.8132 3.49122 33.6621L1.43238 38.9586",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30V39.5M36 22V39.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4747 21.0987L28.5092 18.6139C29.3583 18.2642 29.8094 17.3327 29.5571 16.4498C29.2605 15.4117 28.1248 14.8647 27.1282 15.2799L24.1132 16.5362C23.3829 16.8405 22.7148 17.3093 22.3154 17.9924C21.7658 18.9322 21.5327 19.7913 21.4624 20.4516C21.4035 21.0041 21.961 21.3102 22.4747 21.0987Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 14.5L33 13.5M31 16L32 15.6",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5C25 15.0523 24.5523 15.5 24 15.5C23.4477 15.5 23 15.0523 23 14.5C23 13.9477 23.4477 13.5 24 13.5C24.5523 13.5 25 13.9477 25 14.5Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 14V11M21.5 12.5L22.5 13.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 49,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKindergarten);
export default __webpack_public_path__ + "static/media/Kindergarten.1d6c9fcb5def796052238696b5a5b7f7.svg";
export { ForwardRef as ReactComponent };